export const carouselImages = [
    {
        "imagen" : "./assets/imgs/fondos/img1.jpg"
    },
    {
        "imagen" : "./assets/imgs/fondos/img2.jpg"
    },
    {
        "imagen" : "./assets/imgs/fondos/img3.jpg"
    },
    {
        "imagen" : "./assets/imgs/fondos/img4.jpg"
    },
    {
        "imagen" : "./assets/imgs/fondos/img5.jpg"
    },
    {
        "imagen" : "./assets/imgs/fondos/img6.jpg"
    }
]